import * as apiFunction from '@services/apiFunctions'

import { API_URLS } from '@services/apiRoutes'

import type {
  GetPreviaSemanalRequestProps,
  LiberarPreviaSemanalRequestProps,
  PreviaSemanalResponseProps,
  SubmitPreviaSemanalRequestProps
} from './types'

export const getPreviaSemanal = async (
  payload: GetPreviaSemanalRequestProps
): Promise<PreviaSemanalResponseProps> => {
  return await apiFunction.apiRequestWithBody({
    url: API_URLS.finapi.consolidatedEntry,
    method: 'POST',
    body: payload
  })
}

export const submitPreviaSemanal = async (
  payload: SubmitPreviaSemanalRequestProps
): Promise<PreviaSemanalResponseProps> => {
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.consolidatedEntry}/previa-semanal`,
    method: 'POST',
    body: payload
  })
}

export const liberarPreviaSemanal = async (
  payload: LiberarPreviaSemanalRequestProps
): Promise<PreviaSemanalResponseProps> => {
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.consolidatedEntry}/liberar-previa-semanal`,
    method: 'PATCH',
    body: payload
  })
}
